export const Constant = {
    defaultPageSize:20,
    defaultPageNumber:1,
	defaultDropdownPageSize:100,
    paginationRowsPerPageOptions:[5,10,20,40],
    defaultAlertVarient:'warning',
    defaultAlertShowTime:7000
}
